import markerShadow from 'leaflet/dist/images/marker-shadow.png'
import L from 'leaflet'
import {
    REPORT_SEVERITY,
    SEVERITY_THEME_COLOR_MAP
} from '../../root/hooks/useReportTypes'

const ActiveIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-device-active.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-device-active.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const ErrorIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-device-error.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-device-error.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const CatchIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-device-catch.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-device-catch.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const WarningIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-device-warning.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-device-warning.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const PowerIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-device-power.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-device-power.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const RefreshIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-device-refresh.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-device-refresh.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const RouterInactiveIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-router-inactive.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-router-inactive.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const RouterActiveIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-router-active-v2.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-router-active-v2.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
const RouterOfflineIcon = new L.icon({
    iconUrl: require('../../../assets/svg/floor-router-inactive.svg'),
    iconRetinaUrl: require('../../../assets/svg/floor-router-inactive.svg'),
    iconAnchor: [20, 72],
    popupAnchor: [0, -64],
    shadowUrl: markerShadow,
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 80),
    className: 'leaflet-div-icon'
})
export const CautionIcon = new L.icon({
    iconUrl: require('../../../assets/svg/caution.svg'),
    iconRetinaUrl: require('../../../assets/svg/caution.svg'),
    iconAnchor: [10, 60],
    popupAnchor: [0, -64],
    shadowSize: [40, 80],
    shadowAnchor: [6, 80],
    iconSize: new L.Point(40, 40),
    className: 'leaflet-div-icon'
})

export const GetMarkerIcon = (severity, isNetworkDevice, device) => {
    if (isNetworkDevice) {
        if (device.data?.tti?.status === 'connected') {
            return RouterActiveIcon
        } else {
            return RouterInactiveIcon
        }
    }
    //TODO add separate icon for down
    if (severity === REPORT_SEVERITY.critical) {
        return ErrorIcon
    }
    if (severity === REPORT_SEVERITY.catch) {
        return CatchIcon
    }
    if (severity === REPORT_SEVERITY.warning) {
        return WarningIcon
    }
    if (severity === REPORT_SEVERITY.inactive) {
        return PowerIcon
    }
    if (severity === REPORT_SEVERITY.info) {
        return ActiveIcon
    }
    return PowerIcon
}

export const getLocationSeverityByDevices = location => {
    if (!location) {
        return REPORT_SEVERITY.inactive
    }

    if (location.devices_critical > 0) {
        return REPORT_SEVERITY.critical
    }

    if (location.devices_critical === 0 && location.devices_warning > 0) {
        return REPORT_SEVERITY.warning
    }

    if (
        location.devices_critical === 0 &&
        location.devices_warning === 0 &&
        location.devices_active > 0
    ) {
        return REPORT_SEVERITY.info
    }

    return REPORT_SEVERITY.inactive
}

export const GetMarkerIconByLocation = location => {
    const locationSeverity = getLocationSeverityByDevices(location)
    if (locationSeverity === REPORT_SEVERITY.critical) {
        return ErrorIcon
    }

    if (locationSeverity === REPORT_SEVERITY.warning) {
        return WarningIcon
    }

    if (locationSeverity === REPORT_SEVERITY.info) {
        return ActiveIcon
    }

    return PowerIcon
}

export const getSerialNumberIcon = device => {
    return L.divIcon({
        html: `<div style="background: white; padding: 3px 6px; text-align: center; border-radius: 10px; border: 1px solid grey; opacity: 0.9;">${device.serial_number}</div>`,
        iconSize: [100, 20],
        iconAnchor: [50, 83]
    })
}

export const getDeviceNameIcon = device => {
    return L.divIcon({
        html: `<div style="background: white; padding: 3px 6px; text-align: center; border-radius: 10px; border: 1px solid grey; opacity: 0.9;">${device.name}</div>`,
        iconSize: [100, 20],
        iconAnchor: [50, 83]
    })
}

export const getSerialNumberAndDeviceNameIcon = device => {
    return L.divIcon({
        html: `<div style="background: white; padding: 3px 6px; text-align: center; border-radius: 10px; border: 1px solid grey; opacity: 0.9;">${device.name}<br>${device.serial_number}</div>`,
        iconSize: [100, 20],
        iconAnchor: [50, 83]
    })
}

export const getFlashingIcon = () => {
    return L.divIcon({
        className: 'flashing-marker',
        html: `<div style="width: 30px; height: 30px; border-radius: 60px;"></div>`,
        iconSize: [100, 100],
        iconAnchor: [50, 84]
    })
}

export const getLocationDotColor = (location, theme) => {
    const locationSeverity = getLocationSeverityByDevices(location)
    return theme[SEVERITY_THEME_COLOR_MAP[locationSeverity]] || theme.secondary
}

export const locationHasNoDevices = location => {
    return (
        !location ||
        (location.devices_critical === 0 &&
            location.devices_warning === 0 &&
            location.devices_active === 0 &&
            location.devices_inactive === 0)
    )
}
